import { create } from "zustand"

interface UpdateStore {
  needRefresh: boolean
  updateSW: (() => void) | null
  setNeedRefresh: (fn: () => void) => void
  dismiss: () => void
}

export const useUpdateStore = create<UpdateStore>((set) => ({
  needRefresh: false,
  updateSW: null,
  setNeedRefresh: (fn) => set({ needRefresh: true, updateSW: fn }),
  dismiss: () => set({ needRefresh: false, updateSW: null }),
}))
